<template>
  <div v-if="selectedReference" class="sidepanel">
    <div class="header">
      <div class="source">
        <BbIcon size="small" name="veeva" class="colored-veeva" />
        <TextBody tag="span" i18n-key="collections.createPopup.fromVault"></TextBody>
      </div>
      <BbBtn size="x-small" type="icon" icon="x-small" icon-size="medium" no-background @click="onClose"></BbBtn>
    </div>
    <DocumentContainer />
  </div>
  <DocumentSkeletonLoader v-else />
</template>

<script>
import useModals from '~/composables/useModals';
import useDocuments from '~/composables/useDocuments';
import DocumentContainer from '~/components/conversation/DocumentContainer';
import DocumentSkeletonLoader from '~/components/conversation/documentPanel/DocumentSkeletonLoader';
import TextBody from '~/components/common/TextBody';

export default {
  components: { DocumentContainer, DocumentSkeletonLoader, TextBody },
  setup() {
    const { setCurrentDocumentsDialog } = useModals();
    const { selectedReference } = useDocuments();

    const onClose = () => {
      setCurrentDocumentsDialog(null);
    };

    return {
      selectedReference,
      onClose,
    };
  },
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}

// need to make the container scrollable when viewport height smaller
@media (max-height: 750px) {
  .sidepanel {
    overflow: auto;
  }
}

.sidepanel {
  @include media-breakpoint-up('sm') {
    display: flex;
  }

  max-height: calc(100vh - 80px);

  // take into consideration the margins
  height: 100%;
  display: none;
  flex-direction: column;
  background-color: $bb-neutral-0;
  border-radius: $bb-spacing-8;
  border: 1px solid #cecdcb;
  box-shadow: 0 0 $bb-spacing-2 0 #0000001a;
  align-items: center;
  min-width: 348px;
  max-width: 348px;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: $bb-spacing-4;

    .source {
      @include bb-base-font-family;
      @include bb-regular-text-styles('md');
      display: flex;
      gap: $bb-spacing-2;
      align-items: center;
    }

    .colored-veeva {
      color: orange;
      background-color: $bb-neutral-0;
      border-radius: $bb-spacing-8;
      padding: $bb-spacing-1;
    }

    :deep(button .v-btn__content) {
      i {
        background-color: $bb-neutral-0;
      }
    }
  }
}
</style>
